export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '관리감독자'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).companyName // 사업장명
        case 1: return func.getContent(value).inputC_1 // 관리감독자
        case 3: return func.getCreatedDate(value.created_at) // 등록일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
      case '사업장명': return ['content$body.companyName*%[:default_skw]%']
      case '관리감독자': return ['content$body.inputC_1*%[:default_skw]%']
      case '소속명': return ['content$body.inputC_2*%[:default_skw]%']
      case '부서명': return ['content$body.stdInfo.com_name*%[:default_skw]%']
      case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
  },
}
